// 顶部导航 / 底部 / 语言切换
export default {
  brand: {
    name: 'IEasyTool',
    slogan: '让工作更简单'
  },
  nav: {
    home: '首页',
    favorites: '收藏',
    category: '分类'
  },
  footer: {
    home: '首页',
    contact: '联系我们',
    terms: '服务协议',
    privacy: '隐私政策',
    partners: '合作伙伴',
    disclaimer: '本站工具仅供学习交流，严禁用于任何违法违规用途'
  },
  lang: {
    zh: '中文',
    en: 'English',
    switch: '语言'
  },
  ad: {
    promo: '推广',
    recommend: '推荐'
  }
}
